import { findKey } from "lodash";

export const getDefaultMarketId = (marketTranslations, marketId) => {
  if (typeof marketId !== "string") {
    return marketId;
  }

  const normalizedMarketId = marketId.toLowerCase();

  return (
    findKey(marketTranslations, function(item) {
      return item.pl === normalizedMarketId || item.en === normalizedMarketId;
    }) || marketId
  );
};
